export default {
    namespaced: true,
    state: () => ({
        chessProgress: null,
        singingProgress: null
    }),
    mutations: {
        SET_CHESS_PROGRESS(state, data) {
            state.chessProgress = data;
        },
        SET_SINGING_PROGRESS(state, data) {
            state.singingProgress = data;
        }
    },
    actions: {
        loadProgress({ commit }) {
            try {
                const chess = localStorage.getItem('chessProgress');
                const singing = localStorage.getItem('singingProgress');
                if (chess) commit('SET_CHESS_PROGRESS', JSON.parse(chess));
                if (singing) commit('SET_SINGING_PROGRESS', JSON.parse(singing));
            } catch (e) {
                console.error('Error loading progress:', e);
            }
        }
    },
    getters: {
        chessProgress: (state) => state.chessProgress,
        singingProgress: (state) => state.singingProgress
    }
};
